import { Box } from "@mui/material";
import React from "react";
import { useTheme } from "../../style/theme";

const Registration = () => {
  const { mode } = useTheme();

  return (
    <Box sx={{ backgroundColor: "background.default" }} p={1}>
      <Box className="h-80 w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 mb-2">
        <Box
          className={`h-full w-full p-3  shadow-md rounded-xl border overflow-hidden ${mode === "dark"
            ? "border-[#292929] bg-neutral-1000"
            : "bg-neutral border-[#292929]"
            } `}
        ></Box>
        <Box
          className={`p-3 rounded-xl border shadow-md ${mode === "dark"
            ? "border-[#292929] bg-neutral-1000"
            : "bg-neutral border-[#292929]"
            }`}
        ></Box>
      </Box>
    </Box>
  );
};

export default Registration;
